import { render, staticRenderFns } from "./CallButtons.vue?vue&type=template&id=94147098&scoped=true"
import script from "./CallButtons.vue?vue&type=script&lang=js"
export * from "./CallButtons.vue?vue&type=script&lang=js"
import style0 from "./CallButtons.vue?vue&type=style&index=0&id=94147098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94147098",
  null
  
)

export default component.exports